import { Card, Col, Row, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppStateContext } from "../../context/AppContext";
import Predefined from "./Predefined";
import Creative from "./Creative";
import {
  CategoryChallengePieChart,
  DurationChallengePieChart,
  EmotionChallengePieChart,
} from "../../components/Chart/ChallengePieChart";

import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

const { TabPane } = Tabs;

const cmsTabs = {
  PREDEFINED: "predefined",
  CREATIVE: "Creative",
};

function Index() {
  const { setPageHeading } = useContext(AppStateContext);
  const params = new URLSearchParams(window.location.search)
  const paramsTab = params.get("tab")
  const [selectedTab, setSelectedTab] = useState(paramsTab ? paramsTab : "predefined");
  const [pieChart, setPieChart] = useState();
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const handleTabChange = (status) => {
    setSelectedTab(status);
  };

  const fetchData = () => {
    request({
      url: apiPath.getChallengePieChart,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setPieChart(data?.data);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    setPageHeading("Challenge Management");
    fetchData();
  }, []);

  return (
    <>
      <div className="tabled quoteManagement">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <Tabs
                className="main_tabs"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >
                <TabPane tab={cmsTabs.PREDEFINED} key={"predefined"}>
                  <div className="cms-bodycontent">
                    <Predefined />
                  </div>
                </TabPane>
                <TabPane tab={cmsTabs.CREATIVE} key={"creative"}>
                  <Creative />
                </TabPane>
              </Tabs>
            </Card>
          </Col>
        </Row>
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <Row gutter={[24, 32]}>
                <Col xs={24}  md={12} xxl={8}>
                  <DurationChallengePieChart data={pieChart} />
                </Col>
                <Col xs={24}  md={12} xxl={8}>
                  <CategoryChallengePieChart data={pieChart} />
                </Col>
                <Col xs={24}  md={12} xxl={8}>
                  <EmotionChallengePieChart data={pieChart} />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
